import * as React from "react";
import ChipsCell from "components/common/ChipsCell";
import { TacticTechnique } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const TacticsTechniquesColumnCell = ({ entity }) => /* @__PURE__ */ React.createElement(ChipsCell, { items: entity.tactics_techniques, renderItem: (id) => /* @__PURE__ */ React.createElement(TacticTechnique, { value: id }) });
export default TacticsTechniquesColumnCell;
